/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserReportResponse } from '../../models/get-user-report-response';
import { UserStatus } from '../../models/user-status';

export interface GetUserReport$Params {

/**
 * the page number.
 */
  page?: number;

/**
 * the size of a page
 */
  size?: number;

/**
 * sort
 */
  sort?: string;

/**
 * Search user reports by email, full name, EPN, designation
 */
  search?: string;
  status?: Array<UserStatus>;
  applications?: Array<string>;
}

export function getUserReport(http: HttpClient, rootUrl: string, params?: GetUserReport$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserReportResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserReport.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
    rb.query('status', params.status, {});
    rb.query('applications', params.applications, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserReportResponse>;
    })
  );
}

getUserReport.PATH = '/api/administration/reports/users';
